/* MOTUS: przycisk "Porównaj" przy tytule na karcie produktu (snippets/motus-porownaj.liquid, style assets/motus-porownaj.css).
   - lista porównania = localStorage, klucz data-key (motus-porownanie:<uchwyt strony porównywarki>), tablica uchwytów produktów,
     najwyżej data-max (4). Tę samą listę czyta i zapisuje assets/motus-porownanie.js na stronie porównywarki.
   - klik dodaje albo usuwa model (aria-pressed), komunikat pod przyciskiem + "Porównaj teraz" (?modele=h1,h2),
     ogłoszenie dla czytnika w osobnym regionie aria-live="polite". Komunikat zamyka X, Esc, klik obok albo Tab poza komponent.
   - gdy localStorage nie działa (wyjątek), przycisk zostaje zwykłym linkiem <a> do porównywarki z ?modele=<uchwyt>.
   Rejestr zmian: CUSTOMIZATIONS.md */
(() => {
  if (customElements.get('motus-porownaj')) return;

  const storageWorks = () => {
    try {
      const probe = '__motus_cmp_probe';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  };

  const readList = (key) => {
    try {
      const value = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string' && handle) : [];
    } catch (error) {
      return [];
    }
  };

  const writeList = (key, list) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
      return true;
    } catch (error) {
      return false;
    }
  };

  class MotusPorownaj extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      const link = this.querySelector('a.motus-cmp__btn');
      if (!link || !this.dataset.key || !this.dataset.handle || !storageWorks()) return;

      this.key = this.dataset.key;
      this.handle = this.dataset.handle;
      this.max = parseInt(this.dataset.max, 10) || 4;
      this.fallbackUrl = link.href;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = link.className;
      button.setAttribute('aria-pressed', 'false');
      while (link.firstChild) button.appendChild(link.firstChild);
      link.replaceWith(button);
      this.button = button;

      this.toast = this.querySelector('[data-toast]');
      this.message = this.querySelector('[data-msg]');
      this.go = this.querySelector('[data-go]');
      this.live = this.querySelector('[data-live]');
      this.closeButton = this.querySelector('[data-close]');

      button.addEventListener('click', () => this.toggle());
      if (this.closeButton) this.closeButton.addEventListener('click', () => this.hideToast(true));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.toast && !this.toast.hidden) {
          event.stopPropagation();
          this.hideToast(true);
        }
      });
      // Tab poza przycisk i komunikat zamyka komunikat (nie zostaje nad treścią, po której idzie fokus)
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.hideToast(false);
      });
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.hideToast(false);
      };
      this.onStorage = (event) => {
        if (event.key === null || event.key === this.key) this.render();
      };
      this.onPageShow = () => {
        this.hideToast(false);
        this.render();
      };
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('storage', this.onStorage);
      window.addEventListener('pageshow', this.onPageShow);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('storage', this.onStorage);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    text(name, count) {
      return (this.dataset[name] || '').replace('{n}', String(count)).replace('{max}', String(this.max));
    }

    compareUrl(list) {
      const url = new URL(this.dataset.page || this.fallbackUrl, window.location.origin);
      url.search = '';
      if (list.length) url.searchParams.set('modele', list.join(','));
      return url.pathname + url.search.replace(/%2C/gi, ',');
    }

    render(list = readList(this.key)) {
      const added = list.includes(this.handle);
      this.button.setAttribute('aria-pressed', String(added));
      this.button.title = this.dataset[added ? 'titleRemove' : 'titleAdd'] || '';
      if (this.go) {
        this.go.hidden = list.length === 0;
        this.go.href = this.compareUrl(list);
      }
    }

    toggle() {
      const list = readList(this.key);
      const index = list.indexOf(this.handle);
      let message;
      if (index > -1) {
        list.splice(index, 1);
        message = this.text('textRemoved', list.length);
      } else if (list.length >= this.max) {
        message = this.text('textFull', list.length);
        this.render(list);
        this.showToast(message);
        return;
      } else {
        list.push(this.handle);
        message = this.text('textAdded', list.length);
      }
      if (!writeList(this.key, list)) {
        window.location.href = this.fallbackUrl;
        return;
      }
      this.render(list);
      this.showToast(message);
    }

    showToast(message) {
      if (!this.toast) return;
      if (this.message) this.message.textContent = message;
      this.toast.hidden = false;
      this.toast.classList.remove('motus-cmp__toast--start');
      // komunikat od prawej krawędzi przycisku; gdy wszedłby na galerię albo poza ekran (przycisk pod tytułem, z lewej), od lewej
      const box = this.getBoundingClientRect();
      const area = (this.closest('.product__info') || document.body).getBoundingClientRect();
      if (box.right - this.toast.offsetWidth < Math.max(area.left, 8)) this.toast.classList.add('motus-cmp__toast--start');
      if (this.live) {
        this.live.textContent = '';
        window.clearTimeout(this.liveTimer);
        this.liveTimer = window.setTimeout(() => {
          this.live.textContent = message;
        }, 60);
      }
    }

    hideToast(returnFocus) {
      if (!this.toast || this.toast.hidden) return;
      const focusInside = this.toast.contains(document.activeElement);
      this.toast.hidden = true;
      if (returnFocus || focusInside) this.button.focus();
    }
  }

  customElements.define('motus-porownaj', MotusPorownaj);
})();
